import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CheckoutFlowService } from "../checkout-flow-service";
import { Subscription } from "rxjs";
import { customCheckoutConfig } from "../checkout-config";
import { NgClass } from "@angular/common";
import { PageSlotComponent } from "@spartacus/storefront";

@Component({
    selector: "app-checkout-steps-accordion",
    templateUrl: "./kn-br-custom-checkout-accordion.component.html",
    styleUrl: "./kn-br-custom-checkout-accordion.component.scss",
    imports: [NgClass, PageSlotComponent],
})
export class CheckoutStepsAccordionComponent implements OnInit, OnDestroy {
  deliveryMode: string = "pickUp";
  allSubscriptions = new Subscription();
  currentStepIndex = -1;

  pickupPersonRoute = "checkout/pickup-person";
  pickupStoreRoute = "checkout/pickup-store";
  pickupPayment = "/checkout/payment";

  deliveryAddressRoute = "checkout/delivery-address";
  scheduleDeliveryRoute = "checkout/schedule-delivery";
  deliveryInstructionsRoute = "checkout/delivery-instructions";
  deliveryPaymentRoute = "checkout/payment";
  selectedDate:any;
  currentRoute = '';

  showAddressEdit = true;
  showScheduleEdit = true;
  showInstructionsEdit = true;
  showPaymentEdit = true;
  showPickupPersonEdit = true;
  showPickupStoreEdit = true;
  disableAllAccordions = false;

  constructor(
    private checkoutFlowService: CheckoutFlowService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.allSubscriptions.add(this.checkoutFlowService.cartCreditInfo$.subscribe(res => {
      this.disableAllAccordions = res;
      this.cdr.detectChanges();
    }))
    this.checkoutFlowService.selectedDate$.subscribe((res) => { this.selectedDate = res })
    this.allSubscriptions.add(
      this.checkoutFlowService.mode$.subscribe((mode) => {
        if (mode) {
          this.deliveryMode = mode;
          this.currentRoute = this.router.url;

          const steps = customCheckoutConfig[this.deliveryMode].steps;
          this.currentStepIndex = steps.findIndex((step) =>
            this.currentRoute.includes(step.routeName)
          );       
        }
      })
    );

    const routeEditMap = [
      { route: this.deliveryAddressRoute, flag: 'showAddressEdit' },
      { route: this.scheduleDeliveryRoute, flag: 'showScheduleEdit' },
      { route: this.deliveryInstructionsRoute, flag: 'showInstructionsEdit' },
      { route: this.pickupPersonRoute, flag: 'showPickupPersonEdit' },
      { route: this.pickupStoreRoute, flag: 'showPickupStoreEdit' },
      { route: this.deliveryPaymentRoute, flag: 'showPaymentEdit' },
      { route: this.pickupPayment, flag: 'showPaymentEdit' }
    ];

    for (const { route, flag } of routeEditMap) {
      if (this.currentRoute.includes(route)) {
      this[flag] = false;
      break;
      }
    }
  }

  goToCheckoutPage(routeValue) {
    this.router.navigateByUrl(routeValue);
  }

  isStepEnabled(stepIndex: number): boolean {
    return stepIndex <= this.currentStepIndex;
  }

  isRouteMatch(routeValue) {
    return this.router.url.includes(routeValue);
  }

  ngOnDestroy(): void {
    this.allSubscriptions?.unsubscribe();
  }
}
